import React, { useState, useEffect } from 'react';
import Header from './Header';
import VictoryDetail from './Page';
import LoaderInside from './LoaderInside';
import Vict1 from "../assets/victory/vict1.png";
import Vict3 from "../assets/victory/vict3.png";
import Vict4 from "../assets/victory/vict4.png";
import Vict5 from "../assets/victory/vict5.png";
import Locker from "../assets/locker.svg";

const Victories = React.memo(() => {
    const [selectedVictory, setSelectedVictory] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, []);

    const handleVictorySelect = (title) => {
        setSelectedVictory(title);
    };

    if (isLoading) {
        return <div className="main-load"><LoaderInside /></div>;
    }

    if (selectedVictory) {
        return (<><Header /><VictoryDetail title={selectedVictory} setSelected={setSelectedVictory} /></>);
    }

    return (
        <>
            <Header />
            <div className="victories-container">
                <h1 className="victories-title">ФУНДАМЕНТ КЛУБА "АПГРЕЙД"</h1>

                <div className="victories-grid">
                    <button className="victory-card" onClick={() => handleVictorySelect('Физическая победа')}>
                        <img src={Vict1} alt="" className="victory-image" />
                        <span className="victory-title">ФИЗИЧЕСКАЯ ПОБЕДА</span>
                    </button>

                    <button className="victory-card" onClick={() => handleVictorySelect('Ментальная победа')}>
                        <img src={Vict4} alt="" className="victory-image" />
                        <span className="victory-title">МЕНТАЛЬНАЯ ПОБЕДА</span>
                    </button>
                    <button className="victory-card" onClick={() => handleVictorySelect('Духовная победа')}>
                        <img src={Vict5} alt="" className="victory-image" />
                        <span className="victory-title">ДУХОВНАЯ ПОБЕДА</span>
                    </button>
                    <button className="victory-card locked-victory" disabled>
                        <div className="locked-overlay">
                            <img src={Locker} alt="Заблокировано" className="locker-icon" />
                        </div>
                        <img src={Vict3} alt="" className="victory-image" />
                        <span className="victory-title">КАРЬЕРНАЯ ПОБЕДА</span>
                    </button>


                </div>
            </div>
        </>
    );
});

export default Victories;
